<template>
  <v-card rel="noopener" target="_blank" rounded="lg" elevation="0" border>
    <template #title>
      <span class="source-connect-card__title d-inline-flex align-center gap-2">
        <v-icon icon="mdi-link-variant" size="22" class="text-medium-emphasis" />
        <span>Connect a new source</span>
      </span>
    </template>
    <v-card-text class="pa-4 pt-2">
      <v-select
        v-model="selectedFeed"
        class="source-connect-select"
        :items="feeds"
        item-title="title"
        item-value="value"
        label="Source type"
        variant="outlined"
        color="primary"
        density="comfortable"
        hide-details="auto"
        prepend-inner-icon="mdi-source-branch"
        :disabled="state.loading"
        menu-icon="mdi-chevron-down"
      />
    </v-card-text>
    <template v-slot:prepend>
      <img src="/favicon.png" style="height: 60px" />
    </template>
    <template v-slot:actions>
      <v-btn
        color="primary"
        variant="tonal"
        prepend-icon="mdi-plus-circle-outline"
        class="text-transform-none ms-auto"
        :loading="state.loading"
        :disabled="!selectedFeed"
        @click="handleClickConnect"
      >
        Connect
      </v-btn>
    </template>
  </v-card>
</template>

<script setup lang="ts">
import { IApp } from "@/types";
import { getFeedNameFromFeedType, makeAlert } from "@/utils";
import { useAccountStore } from "@/stores/account";
import _ from "lodash";
import useRouteParams from "@/hooks/useRouteParams";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { URLs } from "@/constants";

const accountStore = useAccountStore();
const router = useRouter();

const props = defineProps<{
  userId: string;
}>();

const { customerId } = useRouteParams();
const state = ref({
  loading: false
});

const selectedFeed = ref<IApp.IFeedTypes>(IApp.IFeedTypes.GoogleSearchConsole);
const feeds = [
  {
    value: null,
    title: "Select a source"
  },
  {
    value: IApp.IFeedTypes.GoogleSearchConsole,
    title: getFeedNameFromFeedType(IApp.IFeedTypes.GoogleSearchConsole)
  },
  {
    value: IApp.IFeedTypes.GoogleAnalytics,
    title: getFeedNameFromFeedType(IApp.IFeedTypes.GoogleAnalytics)
  },
  { value: IApp.IFeedTypes.BirdEye, title: getFeedNameFromFeedType(IApp.IFeedTypes.BirdEye) }
];

const handleClickConnect = async () => {
  state.value.loading = true;
  switch (selectedFeed.value) {
    case IApp.IFeedTypes.GoogleSearchConsole: {
      const response = await accountStore.createOAuthURL(
        props.userId,
        customerId?.value!,
        selectedFeed.value!
      );
      if (response.status) {
        window.open(response.data.url, "_blank")?.focus();
      } else {
        makeAlert(response.message, "error");
      }
      break;
    }
    case IApp.IFeedTypes.BirdEye:
      router.push(URLs.PAGE_SOURCE_CONNECT(customerId.value!, selectedFeed.value));
      break;
    case IApp.IFeedTypes.GoogleAnalytics: {
      const response = await accountStore.createOAuthURL(
        props.userId,
        customerId?.value!,
        selectedFeed.value!
      );
      if (response.status) {
        window.open(response.data.url, "_blank")?.focus();
      } else {
        makeAlert(response.message, "error");
      }
      break;
    }
    default:
      makeAlert("Coming soon!");
      break;
  }
  state.value.loading = false;
};
</script>

<style scoped>
:deep(.v-card-actions) {
  padding: 8px var(--thor-profile-card-padding) var(--thor-profile-card-padding);
}

.source-connect-select :deep(.v-field) {
  border-radius: 8px;
}

.source-connect-select :deep(.v-field__outline) {
  --v-field-border-opacity: 0.22;
}

.source-connect-select :deep(.v-field--focused .v-field__outline) {
  --v-field-border-width: 2px;
}
</style>
